// extracted by mini-css-extract-plugin
module.exports = {"column":"styles_column__C_8Sm","imageContainer":"styles_imageContainer__rlM0d","image":"styles_image__Arpuw","back":"styles_back__MX1bs","text":"styles_text__MBbRe"};